module.exports = __webpack_public_path__ + "overview.8fd5a59111dbb6fea367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/overview.jpg
// module id = 1965
// module chunks = 2